import { render } from "./App.vue?vue&type=template&id=51378f15"
const script = {}

import "./App.vue?vue&type=style&index=0&id=51378f15&lang=css"
script.render = render

export default script